import { applyMiddleware, combineReducers, compose,createStore,} from 'redux';
import BannersReducer from './reducers/BannersReducer';
import {thunk} from 'redux-thunk';
import { AuthReducer } from './reducers/AuthReducer';
import  CategoryReducer  from './reducers/CategoryReducer';
import ToppicksReducer from './reducers/ToppicksReducer';
import ShopsReducer from './reducers/ShopsReducer';
import toastReducer from 'ToastMassage/toastReducer';
import CouponReducer from './reducers/CouponReducer';
import OfferReducer from './reducers/OfferReducer';
import PlanReducer from './reducers/PlanReducer';
import VendorReducer from './reducers/VendorReducer';
import LandingReducer from './reducers/LandingReducer';
import UserReducer from './reducers/UserReducer';
import User_FEVReducer from './reducers/UserFevReducer';

import ProductRequestReducer from './reducers/ProductRequestReducer';
import DocumentReducer from './reducers/DocumentReducer';
import ReviewReducer from './reducers/ReviewReducer';
import RoleReducer from './reducers/RoleReducer';
import ModuleReducer from './reducers/ModuleReducer';

const middleware = applyMiddleware(thunk);

const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const reducers = combineReducers({
    banners: BannersReducer,
    auth: AuthReducer,
    categories: CategoryReducer,
	toppicks: ToppicksReducer,
    shops: ShopsReducer,
    coupon: CouponReducer,
    offer: OfferReducer,
    plan: PlanReducer,
    vendor: VendorReducer,
    toast: toastReducer,
    landing:LandingReducer,
    users:UserReducer,
    userFev:User_FEVReducer,
    productRequest:ProductRequestReducer,
    document: DocumentReducer,
    review: ReviewReducer,
    role :RoleReducer,
    module: ModuleReducer
});

export const store = createStore(reducers,  composeEnhancers(middleware));
